/* Pay in 4 line under the product page price. Australia and Canada only: see snippets/ir-pay-in-4.liquid. */
(function () {
  var config = document.getElementById('ir-pay-in-4');
  if (!config) return;
  var via = config.getAttribute('data-via');
  var cap = parseFloat(config.getAttribute('data-cap')) || Infinity;
  var line = null;

  function visible(el) {
    return el.offsetParent !== null && el.getBoundingClientRect().width > 0;
  }

  function findPrice() {
    var selectors = ['.ir-sale-current-price', '[data-ir-v5-bind="priceLabel"]', '[data-ir-hat-price]', '[data-ir-variant-price]'];
    for (var i = 0; i < selectors.length; i++) {
      var found = Array.prototype.slice.call(document.querySelectorAll(selectors[i])).filter(visible);
      if (found.length) {
        found.sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top; });
        return found[0];
      }
    }
    return null;
  }

  // Step out of the row holding the price, compare price and saving, so the line sits below all three.
  function rowOf(price) {
    var el = price;
    while (el.parentElement && el.parentElement !== document.body) {
      var style = getComputedStyle(el.parentElement);
      var isRow = style.display.indexOf('flex') > -1 && style.flexDirection.indexOf('row') > -1;
      var isInline = style.display.indexOf('inline') > -1 || style.display === 'contents';
      if (!isRow && !isInline && getComputedStyle(el).display.indexOf('inline') === -1) break;
      el = el.parentElement;
    }
    return el;
  }

  function parsePrice(text) {
    var match = /([^\d\s]*)\s?(\d[\d,]*(?:\.\d+)?)/.exec(text || '');
    if (!match) return null;
    var total = parseFloat(match[2].replace(/,/g, ''));
    return total > 0 ? { symbol: match[1] || '$', total: total } : null;
  }

  function instalment(parsed) {
    var each = Math.ceil(parsed.total * 100 / 4) / 100;
    return parsed.symbol + each.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function paint() {
    var price = findPrice();
    if (!price) return;
    var parsed = parsePrice(price.textContent);
    if (!line) {
      line = document.createElement('p');
      line.className = 'ir-pay-in-4';
      var row = rowOf(price);
      row.parentElement.insertBefore(line, row.nextSibling);
    }
    line.hidden = !parsed;
    line.textContent = '';
    if (!parsed) return;
    if (parsed.total > cap) {
      line.textContent = 'or pay monthly with Shop Pay';
      return;
    }
    line.appendChild(document.createTextNode('or pay in 4 easy instalments of '));
    var strong = document.createElement('strong');
    strong.textContent = instalment(parsed);
    line.appendChild(strong);
    line.appendChild(document.createTextNode(' via ' + via));
  }

  function start() {
    paint();
    // Variant and wrap choices rewrite the price a moment after the click.
    ['change', 'click'].forEach(function (name) {
      document.addEventListener(name, function () { setTimeout(paint, 150); }, true);
    });
    // Sale pricing can fill the price in after page load.
    setTimeout(paint, 800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
